module.exports = __webpack_public_path__ + "img/bg23.3d37ecc9.jpeg";